import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { isStaff, meQuery } from '@/lib/queries';

export const Route = createFileRoute('/_app/admin')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery());
    if (!isStaff(me)) {
      throw redirect({ to: '/e-files' });
    }
  },
  component: () => <Outlet />,
});
